import {
    GET_MENU_ITEMS
  } from "./actionTypes"

export const getMenuItems = menuItems => ({
    type: GET_MENU_ITEMS,
    payload: menuItems,
  })
  